export default __webpack_public_path__ + "cd0a868bef835beeb45758caaa8d172f.svg";